import { PopUpMessageData } from '@hb/shared'
import { createContext, useContext } from 'react'

export const PopUpMessageContext = createContext<PopUpMessageData>({
  message: null,
  showMessage: () => {},
  showInfo: () => {},
  showSuccess: () => {},
  processResponse: () => ({ error: 'Uninitialized' }),
  showError: () => {},
  closeMessage: () => {},
})

export const usePopUpMessage = () => useContext(PopUpMessageContext)
